import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxDataWidgetComponent,
  OnyxInformationHeadingComponent,
  OnyxLanguagePipe,
} from '@onyx/angular';
import { sumBy } from 'lodash';
import { GoodsSizeType } from '../../../../../../../common/enums/goods-size-type';
import { DimensionsPipe } from '../../../../../../../common/pipes/dimensions.pipe';
import { GoodQuantityPipe } from '../../../../../../../common/pipes/good-quantity.pipe';
import { OrderPointCategory } from '../../../../../common/enums/order-point-category';
import type { Order } from '../../../../../common/interfaces/order';
import type { OrderLoadingGood } from '../../../../../common/interfaces/order-point';

@Component({
  selector: 'app-order-modal-goods',
  imports: [
    OnyxInformationHeadingComponent,
    OnyxDataWidgetComponent,
    OnyxLanguagePipe,
    TranslatePipe,
    GoodQuantityPipe,
    DecimalPipe,
    DimensionsPipe,
  ],
  templateUrl: './order-modal-goods.component.html',
  styleUrl: './order-modal-goods.component.scss',
})
export class OrderModalGoodsComponent {
  public readonly order = input.required<Order>();

  protected readonly GoodsSizeType = GoodsSizeType;

  protected goods = computed<OrderLoadingGood[]>(() =>
    this.order()
      .points.filter((point) => point.category === OrderPointCategory.LOADING)
      .flatMap((point) => point.goods),
  );

  protected totalWeight = computed(() =>
    sumBy(this.goods(), (good) => good.totalWeight ?? 0),
  );
}
